<template>
  <div class="book_today">
    <div class="container">
      <a
        :href="parsedCta.url"
        :target="parsedCta.target"
        v-html="parsedCta.title"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cta: {},
  },

  computed: {
    parsedCta() {
      if (this.cta) {
        return JSON.parse(this.cta);
      } else {
        return null;
      }
    },
  },

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.book_today {
  a {
    color: var(--white);
    text-decoration: none;
    font-size: 40px;
    font-weight: bold;
    transition: 0.2s ease all;
    background: var(--orange);
    grid-column: span 12;
    padding: 50px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: $mobile-xl) {
      padding: 25px;
			font-size: 20px;
    }

    &:hover {
      background: var(--navy);
      transition: 0.2s ease all;
      color: var(--white);
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/BookToday.vue